module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABJ0lEQVRYhe2Y2xKDIAxEl07//5fTBydTQDCQS9XKeSrMQHdNIhFgcS5pdgERjW+eEhFRysfZPuJ/pyTLew2rmWQTX4oGgHH7Y4QYYPEA0DLhibuBXDxnQKQJVwO1eCIqTETgZqAlHtibmH5rCLgY6IlnIiNhNiCJZ3aRcKoJk4FR8UyECbWBWfGMt4m3ZfFXyJyGzYRPOasjwK3ArPhsfbGPlrBW4leYUqhHKz20kZIIMQCU73undG9y+xRaBs7m9gbMRdw7kOppr4OrxmTAegh5cPsUep6BVvcY+dEu8bwIXI2oZm53A1fP8dhycwcoDRzlfOs6Mft2SPUc/+5cQ4omVAbqp+NVxJp9wtppDY0HI665bBGPRsM9AnmB8li7Lqp/Wiz+iQ/BwrpPbhe43gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/IEHOME_A.png
// module id = 71
// module chunks = 0